export default __webpack_public_path__ + "static/media/C970-BF.04781447.webp";